// Central site configuration used for canonical URLs, JSON-LD, and Open Graph.
// Update SITE_URL once you have a production domain.
export const SITE_URL = "https://tribaldesignz.comm";
export const SITE_NAME = "Tribal Designz";
export const SITE_DIVISION = "Pacific Heritage Uniforms";
export const SITE_TAGLINE =
  "Pacific Heritage Uniforms — Custom Samoan, Tongan & Cook Islands polos for churches, choirs, conferences and reunions in NZ";
export const BRAND_PHONE = "+64 22 101 2443";
export const BRAND_PHONE_RAW = "64221012443";
export const BRAND_TIKTOK = "https://www.tiktok.com/@tribaldesignzco";
export const BRAND_INSTAGRAM = "https://instagram.com/tribaldesignznz";
export const BRAND_LOCATION = "Auckland, New Zealand";
export const WHATSAPP_LINK =
  "https://wa.me/64221012443?text=Hi%20Tribal%20Designz%2C%20I%27d%20like%20to%20enquire%20about%20custom%20uniforms";
